import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import MarkDownViewer from "../markdownViewer/MarkDownViewer";

const DescriptionTab = props => {
  let lang = props.lang.toLowerCase();
  if (/-/.test(lang)) lang = lang.split("-")[0];
  return (
    <div>
      <Container className="pl-0 pr-0">
        <Row className="mt-3 row">
          <Col>
            <MarkDownViewer
              lang={lang}
              defaultlanguage="en"
              text={props.text}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withTranslation()(DescriptionTab);
